// extracted by mini-css-extract-plugin
module.exports = {"scoreContainer":"ScoreCard_scoreContainer__ivEAg"};